import { render, staticRenderFns } from "./NameInputForm.vue?vue&type=template&id=dea918c2&scoped=true&"
import script from "./NameInputForm.vue?vue&type=script&lang=js&"
export * from "./NameInputForm.vue?vue&type=script&lang=js&"
import style0 from "./NameInputForm.vue?vue&type=style&index=0&id=dea918c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dea918c2",
  null
  
)

export default component.exports